import React, { useMemo } from "react";
import { useTable, Column, UseTableOptions } from "react-table";
import cx from "classnames";

import "./MITransferTable.scss";

export interface MITransferTableProps<T extends object> extends UseTableOptions<T> {
    caption?: string;
    className?: string;
}

const MITransferTable = <T extends object>(props: MITransferTableProps<T>) => {
    const columns: Column<T>[] = useMemo(() => props.columns, [props.columns]);

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        ...props,
        columns,
    });

    return (
        <table {...getTableProps()} cellPadding="2" className={cx("mit-table", props.className)}>
            <caption>{props.caption}</caption>
            <thead className="mit-table-header">
                {// Loop over the header rows
                headerGroups.map((headerGroup, ind1) => (
                    // Apply the header row props
                    <tr
                        {...headerGroup.getHeaderGroupProps()}
                        className="listheader"
                        key={ind1 + "-header-row"}
                    >
                        {// Loop over the headers in each row
                        headerGroup.headers.map((column, ind2) => (
                            // Apply the header cell props
                            <th
                                {...column.getHeaderProps()}
                                scope="col"
                                className="mit-table-header-cell texttiny"
                                key={ind2 + "-header-cell"}
                            >
                                {// Render the header
                                column.render("Header")}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
                {// Loop over the table rows
                rows.map((row, ind1) => {
                    // Prepare the row for display
                    prepareRow(row);
                    return (
                        // Apply the row props
                        <tr
                            {...row.getRowProps()}
                            className={cx("mit-table-row", { [`listrow${(ind1 % 2) + 1}`]: true })}
                            key={ind1 + "-row"}
                        >
                            {// Loop over the rows cells
                            row.cells.map((cell, ind2) => {
                                // Apply the cell props
                                return (
                                    <td
                                        {...cell.getCellProps()}
                                        className="mit-table-cell texttiny"
                                        key={ind2 + "-cell"}
                                    >
                                        {// Render the cell contents
                                        cell.render("Cell")}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default MITransferTable;
